<template>
  <a-modal
    :visible="visible"
    :title="$t('college.bulletin.config.configurerMarkType')"
    :footer="false"
    width="500px"
    :z-index="3000"
    wrap-class-name="mark-type-settings-modal-wrap"
    @cancel="$emit('cancel')"
  >
    <div v-if="markType">
      <a-form>
        <a-form-item :label="$t('scolarite.coefficient')">
          <a-input-number
            :value="markType.coef"
            @change="handleCoefChange"
            style="width: 100%"
            :min="0.1"
            :step="0.5"
          />
        </a-form-item>
        <a-form-item :label="$t('college.bulletin.config.count')">
          <a-input-number
            :value="markType.count"
            @change="handleCountChange"
            style="width: 100%"
            :min="1"
          />
        </a-form-item>
        <a-form-item :label="$t('scolarite.subsubject')">
          <a-select
            :value="markType.subsubject"
            @change="handleSubsubjectChange"
            :placeholder="$t('scolarite.choisirSubsubject')"
            style="width: 100%"
            allowClear
            :get-popup-container="getPopupContainer"
          >
            <a-select-option
              v-for="subj in subsubjects"
              :key="subj._id"
              :value="subj._id"
            >
              {{ subj.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <div class="form-actions mt-3">
        <a-button type="primary" @click="handleSave">
          {{ $t("action.enregistrer") }}
        </a-button>
        <a-button @click="$emit('cancel')">
          {{ $t("action.annuler") }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "MarkTypeSettingsModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    markType: {
      type: Object,
      default: null,
    },
    subsubjects: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleCoefChange(value) {
      if (this.markType) {
        this.markType.coef = value;
      }
    },
    handleCountChange(value) {
      if (this.markType) {
        this.markType.count = value;
      }
    },
    handleSubsubjectChange(value) {
      if (this.markType) {
        this.markType.subsubject = value;
      }
    },
    handleSave() {
      this.$emit("save");
    },
    getPopupContainer(triggerNode) {
      // Return the modal body to ensure dropdown appears above modal
      const modal = triggerNode.closest('.ant-modal');
      return modal ? modal.querySelector('.ant-modal-body') || modal : document.body;
    },
  },
};
</script>

<style>
/* Ensure the modal appears above other modals */
/* This style is non-scoped because modals are rendered outside the component */

/* Force higher z-index for this specific modal */
.mark-type-settings-modal-wrap {
  z-index: 3000 !important;
}

/* Target the mask when this modal is open - mask is usually the last one */
body > .ant-modal-mask:last-of-type {
  z-index: 2999 !important;
}

/* Fix z-index for select dropdown to appear above modal */
.ant-select-dropdown {
  z-index: 3100 !important;
}
</style>

